export const environment = {
  production: false,
  TITLE: 'Dev Environment Heading',
  api: '',
  APIURL: 'https://dev.sanet.tutumfsw.com',
  portAuth: 'https://dev.sanet.tutumfsw.com',
  portHospital: 'https://dev.sanet.tutumfsw.com',
  portUserAdmin: 'https://dev.sanet.tutumfsw.com',
  portGlobalCat: 'https://dev.sanet.tutumfsw.com',
  portDiagnostic: 'https://dev.sanet.tutumfsw.com',
  portDiagnosticMassive: 'https://dev.sanet.tutumfsw.com',
  portPatients: 'https://dev.sanet.tutumfsw.com',
  portSchedule: 'https://dev.sanet.tutumfsw.com',
  portConsumerKafka: 'https://dev.sanet.tutumfsw.com',
  portProducerKafka: 'https://dev.sanet.tutumfsw.com',
  portHospitalResource: 'https://dev.sanet.tutumfsw.com',
  portReports: 'https://dev.sanet.tutumfsw.com',
  portOperatingRooms: 'https://dev.sanet.tutumfsw.com',
  portFileSystem: 'https://dev.sanet.tutumfsw.com',
};
